import script from "./ApproveClaimModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApproveClaimModal.vue?vue&type=script&setup=true&lang=ts"

import "./ApproveClaimModal.vue?vue&type=style&index=0&id=46d6459a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d6459a"]])

export default __exports__